// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2NnR2","title":"Images90_title__13BPU","images":"Images90_images__2YKpC"};